// Pagine di autenticazione: non fanno parte della navigazione (sidebar, recenti)
export const AUTH_PAGES = [
  "/login",
  "/codice",
  "/codice-otp",
  "/recupera-password",
  "/kiosk",
];
